/*
  CTR gallery dots — the theme ships a "1 / N" counter with arrows under the
  product gallery. On phones we show dots instead: one per slide, the active one
  filled, tap a dot to jump. Falls back silently if the markup isn't there.
*/
(function () {
  function build(counter) {
    if (counter.ctrDots) return;
    var slider = counter.closest('slider-component');
    if (!slider) return;
    var totalEl = counter.querySelector('.slider-counter--total');
    var currentEl = counter.querySelector('.slider-counter--current');
    var total = parseInt(totalEl && totalEl.textContent, 10);
    if (!total || total < 2 || !currentEl) return;

    var dots = document.createElement('div');
    dots.className = 'ctr-dots';
    dots.setAttribute('aria-hidden', 'true');

    for (var i = 0; i < total; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ctr-dot';
      dot.dataset.index = String(i);
      dots.appendChild(dot);
    }

    counter.appendChild(dots);
    counter.ctrDots = dots;

    var sync = function () {
      var current = parseInt(currentEl.textContent, 10) || 1;
      Array.prototype.forEach.call(dots.children, function (dot, index) {
        dot.classList.toggle('ctr-dot--active', index === current - 1);
      });
    };
    sync();

    // the theme rewrites the counter text on every slide change
    if (window.MutationObserver) {
      new MutationObserver(sync).observe(currentEl, { childList: true, characterData: true, subtree: true });
    }

    dots.addEventListener('click', function (event) {
      var dot = event.target.closest('.ctr-dot');
      if (!dot) return;
      var index = parseInt(dot.dataset.index, 10);
      var list = slider.querySelector('.slider');
      if (!list) return;
      var slide = list.children[index];
      if (!slide) return;
      list.scrollTo({ left: slide.offsetLeft - list.offsetLeft, behavior: 'smooth' });
    });
  }

  function init() {
    document
      .querySelectorAll('.product__media-wrapper .slider-counter, media-gallery .slider-counter')
      .forEach(function (counter) {
        try {
          build(counter);
        } catch (e) {
          /* keep the stock counter */
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
